import React from 'react';
import PropTypes from 'prop-types';

import UppyUploader from '@components/common/uppy/main';
import {
  formattedUppyAttachments,
  uniqueFilesByKey,
  duplicateSweetAlertOptions } from '@helpers/uppy';


class GuestUploadUppy extends React.Component {
  triggerUpload = (files) => {
    const { appendFiles } = this.props;
    const uniqFiles = uniqueFilesByKey(files, "md5hash");
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          appendFiles(formattedUppyAttachments(uniqFiles));
        } else {
          appendFiles(formattedUppyAttachments(files));
        }
      });
    } else {
      appendFiles(formattedUppyAttachments(files));
    }
  }

  trigger() {
    return `uppy-guest-upload-trigger-${this.props.uploadLinkKey}`;
  }

  renderArea() {
    return (
      <div id={this.trigger()} className="uppy-guest-upload-area">
        <p>Click to add an asset</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          template="file_ingest"
          handleUpload={this.triggerUpload}
          uniqIdentifier={`guest-upload-uppy-${this.props.uploadLinkKey}`}
          button
          trigger={`#${this.trigger()}`}
        />
      </React.Fragment>
    );
  }
}

GuestUploadUppy.propTypes = {
  uploadLinkKey: PropTypes.string.isRequired,
  appendFiles: PropTypes.func.isRequired
};

export default GuestUploadUppy;
